import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const BareSelect = ({
  options,
  onChange,
  onBlur,
  value,
  name,
  dataqa,
  ariaLabel,
  extraClasses,
  dataTestId,
  defaultValue,
  error,
}) => {
  const theme = useContext(ThemeContext);
  const componentClasses = classNames(`form-control ${extraClasses}`, {
    error,
  });

  return (
    <>
      <select
        aria-label={ariaLabel}
        className={componentClasses}
        data-qa={dataqa}
        data-testid={dataTestId}
        defaultValue={defaultValue}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
      >
        {options.map((item, index) => (
          <option
            key={`select-menu--${index}`}
            label={item.name}
            value={item.value}
          >
            {item?.name || ''}
          </option>
        ))}
      </select>
      <style jsx>{`
        .error.form-control,
        .error.form-control:focus {
          border-color: ${theme.colors.inputinvalidcolor};
        }
      `}</style>
    </>
  );
};

BareSelect.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  dataqa: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  extraClasses: PropTypes.string,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
};

export default BareSelect;
